const initialState = {};

// Remove a assinatura e desfaz o `resumedToId` que apontava para ela — é o
// que faz o painel voltar a mostrar a original.
const withoutSubscription = (subscriptions = {}, id) => Object.fromEntries(
  Object.entries(subscriptions)
    .filter(([key]) => String(key) !== String(id))
    .map(([key, subscription]) => [
      key,
      subscription?.resumedToId === id ? { ...subscription, resumedToId: null } : subscription,
    ]),
);

export default function subscriptionsReducer(state = initialState, action) {
  switch (action.type) {
    // A lista completa do aluno é a fonte da verdade para renovações em
    // "processando": se uma delas não veio, o backend a desfez (recusa que
    // chegou depois de o modal parar de acompanhar — "Pagamento em análise").
    // Só essas saem; o resto continua mesclando como antes.
    case "SUBSCRIPTIONS_FETCHED": {
      const fetched = action.entities.subscriptions || {};
      const kept = Object.fromEntries(
        Object.entries(state).filter(([id, subscription]) => (
          subscription?.lastChargeStatus !== "processing" || fetched[id]
        )),
      );
      return {
        ...kept,
        ...fetched,
      };
    }
    case "PRODUCT_SUBSCRIPTIONS_FETCHED":
    case "SUBSCRIPTION_UPDATED":
      return {
        ...state,
        ...action.entities.subscriptions
      };
    // Renovação cuja 1ª cobrança foi recusada depois de "processando": o
    // backend apaga a assinatura (Pagarme::FailResumedSubscription). Como os
    // fetches só mesclam, sem isto ela continuaria na tela ao lado da original.
    case "SUBSCRIPTION_REMOVED":
      return withoutSubscription(state, action.id);
    default:
      return state;
  }
}
